define([
    'basemodel',
    'appcontext'
], (BaseModel, appContext) => BaseModel.extend({

    urlRoot: '/contracts',

    defaults () {
        return {
            id: null,
            account_id: null,
            payer_id: null,
            payer_name: null,
            number: null,
            date: null,
            end_date: null,
            status_name: appContext.tr('New'),
            additional_contract_start_number: 1,
            status_changed: null,
            status_changed_by: null,
            created_at: null,
            updated_at: null
        };
    }

}));
